var __jsx = React.createElement;
import React from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faMicrophone, faWaveformLines } from "@fortawesome/pro-regular-svg-icons";
var ComingSoonPopup = function ComingSoonPopup(_ref) {
  var feature = _ref.feature,
    isVisible = _ref.isVisible,
    onClose = _ref.onClose;
  if (!isVisible) return null;
  var getTitle = function getTitle() {
    return "Voice Mode Coming Soon";
  };
  var getDescription = function getDescription() {
    return "We're developing voice mode to enhance your interaction with the platform. Stay tuned!";
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-full right-0 mb-2 w-80 bg-gray-700 dark:bg-gray-800 rounded-lg shadow-xl p-5 z-50 border dark:border-gray-700 border-gray-400"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: feature === "mic" ? faMicrophone : faWaveformLines,
    size: "2xl",
    className: "dark:text-teal-500 text-teal-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-base font-medium text-white dark:text-gray-100 mb-2"
  }, getTitle()), /*#__PURE__*/React.createElement("p", {
    className: "text-md text-gray-300 dark:text-gray-300"
  }, getDescription()))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 right-4 transform translate-y-1/2 rotate-45 w-3 h-3 bg-gray-900 dark:bg-gray-800 border-r border-b border-gray-700"
  }));
};
export default ComingSoonPopup;